import React, { createContext } from 'react';
import Theme from '../styles/Theme';

export const ThemeContext = createContext(Theme);

function ThemeProvider({ children }) {
  return <ThemeContext.Provider value={Theme}>{children}</ThemeContext.Provider>;
}

export default ThemeProvider;
